import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IoArrowBackSharp } from "react-icons/io5";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./expenseMangementFormStyle.css";
import CustomAutoCompleteDropdown from "../../../../components/custom_auto_complete_dropdown/CustomAutoCompleteDropdown";
import CustomTextField from "../../../../components/custom_text_field/CustomTextField";
import CustomTextArea from "../../../../components/custom_text_area/CustomTextArea";
import { get_status } from "../../../../api/statusApis";
import { InfoToast, SuccessToast } from "../../../../toast/toasts";
import { LiaExchangeAltSolid } from "react-icons/lia";
function ExpenseManagementForm() {
  const navigate = useNavigate();
  const [isPreviousDate, setIsPreviousDate] = useState(false)
  const { expense_id } = useParams();
  const today = new Date();

  const monthName = today.toLocaleString('default', { month: 'long' });
  const year = today.getFullYear();

  const prevMonthDate = new Date(year, today.getMonth() - 1, 1);
  const prevMonthName = prevMonthDate.toLocaleString('default', { month: 'long' });
  const prevYear = prevMonthDate.getFullYear();
  const [statusOptions, setStatusOptions] = useState([]);
  const [attachments, setAttachments] = useState([]); // for uploaded files

  useEffect(() => {
    fetchStatusList();
    if (expense_id) {
      // TODO: Fetch expense details if editing
    }
  }, [expense_id]);

  const fetchStatusList = () => {
    get_status()
      .then((response) => {
        const options = response.map((item) => ({
          label: item.status_name,
          value: item.id,
        }));
        setStatusOptions(options);
      })
      .catch((error) => console.log(error));
  };

  const formik = useFormik({
    initialValues: {
      expense_head: "",
      amount: "",
      remark: "",
    },
    validationSchema: Yup.object({
      expense_head: Yup.string().required("Expense head is required"),
      amount: Yup.number()
        .typeError("Amount must be a number")
        .required("Amount is required")
        .positive("Amount must be greater than zero"),
      // remark: Yup.string().required("Remark is required"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => {
        formData.append(key, value);
      });
      attachments.forEach((file) => {
        formData.append("attachments[]", file);
      });

      console.log("Submitting Data:", Object.fromEntries(formData.entries()));
      SuccessToast("Form submitted (demo)");
      // Example API call:
      // const apiCall = expense_id ? update_expense_by_id(expense_id, formData) : register_expense(formData);
      // apiCall
      //   .then((res) => {
      //     SuccessToast(expense_id ? "Expense updated!" : "Expense added!");
      //     navigate(-1);
      //   })
      //   .catch((err) => ErrorToast("Something went wrong"));
    },
  });

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setAttachments((prev) => [...prev, ...files]);
  };

  const handleRemoveFile = (index) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const handleReset = () => {
    formik.resetForm();
    setAttachments([]);
  };


  return (
    <div className="expense_management_form_super_container">
      <div className="expense_management_form_sub_container">
        <div className="expense_management_form_single_row_alignment">
          <IoArrowBackSharp
            className="expense_management_form_back"
            onClick={() => navigate(-1)}
          />
          <p className="expense_management_form_title">
            {expense_id
              ? "Update Expense"
              : `Add New Expense - (${isPreviousDate ? `${prevMonthName} ${prevYear}` : `${monthName} ${year}`})`}
          </p>
          <div className="expense_management_icon-button" onClick={() => {
            if(!isPreviousDate){
              InfoToast("You have chosen the previous month and year")
            }
            setIsPreviousDate(!isPreviousDate)
          }}>
            <LiaExchangeAltSolid size={20} />
          </div>
        </div>

        <div className="expense_management_form_single_row_alignment">
          {!expense_id && (
            <button
              className="expense_management_form_reset_button"
              type="button"
              onClick={handleReset}
            >
              Reset
            </button>
          )}
          <button
            className="expense_management_form_save_button"
            type="submit"
            form="expenseform"
          >
            Save
          </button>
        </div>
      </div>

      <form id="expenseform" onSubmit={formik.handleSubmit}>
        <div className="expense_management_form_main_container">
          <p className="expense_management_form_legend">Details</p>

          {/* Expense Head */}
          <div className="expense_management_form_field_block">
            <p className="expense_management_form_label">
              Expense Head <span className="label_required_remark">*</span>
            </p>
            <CustomAutoCompleteDropdown
              name="expense_head"
              placeholder="Select expense head"
              options={statusOptions}
              onChange={(event, newValue) =>
                formik.setFieldValue(
                  "expense_head",
                  newValue ? newValue.value : ""
                )
              }
              onBlur={formik.handleBlur}
              value={
                statusOptions.find(
                  (opt) => opt.value === formik.values.expense_head
                ) || null
              }
              error={
                formik.touched.expense_head &&
                Boolean(formik.errors.expense_head)
              }
              helperText={
                formik.touched.expense_head && formik.errors.expense_head
              }
            />
          </div>

          {/* Amount Field */}
          <div className="expense_management_form_field_block">
            <p className="expense_management_form_label">
              Amount <span className="label_required_remark">*</span>
            </p>
            <CustomTextField
              type="number"
              name="amount"
              placeholder="Enter amount"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.amount}
              error={
                formik.touched.amount && Boolean(formik.errors.amount)
              }
              helperText={formik.touched.amount && formik.errors.amount}
              inputProps={{ inputProps: { min: 0 } }}
            />
          </div>

          {/* Remark Field */}
          <div className="expense_management_form_field_block">
            <p className="expense_management_form_label">
              Remark
            </p>
            <CustomTextArea
              rows={4}
              name="remark"
              placeholder="Enter a remark"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.remark}
              error={formik.touched.remark && Boolean(formik.errors.remark)}
              helperText={formik.touched.remark && formik.errors.remark}
            />
          </div>

        </div>

        <div className="expense_management_form_main_container">
          <p className="expense_management_form_legend">Attachment</p>
          {/* Attachment Upload */}
          <div className="expense_management_form_field_block">
            <input
              type="file"
              multiple
              onChange={handleFileChange}
              className="expense_management_form_file_input"
            />

            {attachments.length > 0 && (
              <div className="expense_management_form_file_list">
                {attachments.map((file, index) => (
                  <div key={index} className="expense_management_form_file_item">
                    <span>{file.name}</span>
                    <button
                      type="button"
                      className="expense_management_form_file_remove_btn"
                      onClick={() => handleRemoveFile(index)}
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

      </form>
    </div>
  );
}

export default ExpenseManagementForm;
